// extracted by mini-css-extract-plugin
module.exports = {"items":"_40d5d0e87d--items--RjETI"};